import { ReactComponent as MenuCloseIcon } from "@/assets/svg/close.svg";
import { ReactComponent as FooterDiscordIcon } from "@/assets/svg/lp-footer-discord.svg";
import { ReactComponent as FooterEmailIcon } from "@/assets/svg/lp-footer-email.svg";
import { ReactComponent as FooterTelegramIcon } from "@/assets/svg/lp-footer-telegram.svg";
import { ReactComponent as FooterTwitterIcon } from "@/assets/svg/lp-footer-twitter.svg";
import { ReactComponent as MenuIcon } from "@/assets/svg/menu.svg";
import ConnectWallet from "@/components/ConnectWallet/ConnectWallet";
import { ENVS } from "@/configs/Configs.env";
import useAccounts from "@/hooks/useAccounts";
import { AuthContext } from "@/providers/AuthProvider";
import addressShorten from "@/utils/addressShorten";
import { Box, Button, Container, Grid, Link, styled } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const DesktopContent = styled("main")(() => ({
  fontFamily: "JetBrainsMono",
  color: "#0D1615",
  letterSpacing: "0.0703846px",

  width: "100%",
  background: "#FEF2D3",
}));

const DesktopHeader = styled(Box)(({ theme }) => ({
  marginBottom: 80,
}));

const DesktopHeaderContent = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    height: "100%",
    position: "relative",
  },
  [theme.breakpoints.up("sm")]: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
}));

const DesktopTopMenu = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "70px",
  padding: "15px 0",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const MobileTopMenu = styled(Box)(({ theme }) => ({
  // marginRight: "24px",
  textAlign: "right",
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
  height: 120,
  paddingTop: 20,
}));

const DesktopButton = styled(Button)(() => ({
  padding: "8px 16px",
  background: "#FFFFFF",
  border: "2px solid #0D1615",
  zIndex: 99,
  boxShadow: "2px 2px 0px #0D1615",
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "18px",
  letterSpacing: "0.07px",
  textTransform: "uppercase",
  color: "#0D1615",
  borderRadius: 0,
}));

const DesktopButtonPS = styled(DesktopButton)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
  background: "#FEF2D3",
  zIndex: 99,

  "& span": {
    marginLeft: "8px",
    color: "#FF768A",
  },

  "& img": {
    height: "19px",
  },
}));
const MobileButtonPS = styled(DesktopButton)(({ theme }) => ({
  background: "#FEF2D3",

  "& span": {
    marginLeft: "8px",
    color: "#FF768A",
  },

  "& img": {
    height: "19px",
  },
}));

const DesktopLogo = styled("img")(() => ({
  height: "50px",
}));
const DesktopBannerLeftGift = styled("img")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    position: "absolute",
    top: "0",
    left: "-25%",
    width: "200px",
  },
  [theme.breakpoints.up("sm")]: {
    position: "absolute",
    top: "0",
    left: "-20%",
    height: "100%",
  },
}));
const DesktopBannerRightGift = styled("img")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    position: "absolute",
    top: "0",
    right: "-25%",
    width: "200px",
  },
  [theme.breakpoints.up("sm")]: {
    position: "absolute",
    top: "0",
    right: "-20%",
    height: "100%",
  },
}));
const DesktopBannerAppLeft = styled("img")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    position: "absolute",
    top: "14.7%",
    left: "2.7%",
    // height: "72.12%",
  },
  [theme.breakpoints.down("lg")]: {
    position: "absolute",
    top: "14.7%",
    zIndex: 99999,
    left: "-15%",
    // height: "72.12%",
  },
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));
const DesktopBannerAppRight = styled("img")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    position: "absolute",
    top: "35.92%",
    right: "7.5%",
    // height: "72.12%",
    zIndex: 100,
  },
  [theme.breakpoints.down("lg")]: {
    position: "absolute",
    top: "35.92%",
    right: "-7.5%",
    // height: "72.12%",
    zIndex: 100,
  },
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));
const DesktopBannerContent = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    padding: " 15px",
  },
  maxWidth: "520px",
  textAlign: "center",
  margin: "0 auto",
}));
const DesktopBannerTopButton = styled(Box)(() => ({
  position: "relative",
  marginTop: "100px",
  marginBottom: "16px",
}));
const DesktopButtonBannerTop = styled(DesktopButton)(() => ({
  background: "#D3FBFE",
  borderRadius: "50px",
}));
const DesktopBannerTopButtonCat = styled("img")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    left: "39%",
  },
  position: "absolute",
  bottom: "53%",
  left: "42%",
  width: "100px",
}));
const DesktopBannerTitle = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    fontSize: "40px",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "60px",
  },
  fontWeight: 500,
  lineHeight: "79px",
  textAlign: "center",
  marginBottom: "24px",
}));
const DesktopBannerDescription = styled(Box)(() => ({
  fontWeight: 300,
  fontSize: "16px",
  lineHeight: "21px",
  textAlign: "center",
}));
const DesktopBannerBottomButton = styled(Box)(() => ({
  position: "relative",
  marginTop: "50px",
}));
const MobileBg = styled(Box)(({ theme }) => ({
  width: "100%",
  // marginTop: "30px",
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));
const DesktopBannerBottomButtonHog = styled("img")(() => ({
  position: "absolute",
  bottom: "54%",
  left: "47%",
  width: "100px",
}));
const DesktopButtonSendToMobile = styled(DesktopButton)(() => ({
  background: "#FED3E7",
  padding: "14px 24px",
}));
const DesktopButtonAvailable = styled(Button)(() => ({
  border: "none",
  background: "unset",
  boxShadow: "unset",
  textTransform: "none",
  "&:hover": {
    border: "none",
    background: "unset",
    boxShadow: "unset",
    textTransform: "none",
  },
}));

const DesktopBody = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    marginTop: -120,
  },
  padding: "0 20px",
}));
const DesktopBodyWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  minHeight: "720px",
  background: "#FFFFFF",
  border: "2px solid #0D1615",
  boxShadow: "3px 3px 0px #0D1615",
  color: "#0D1615",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    textAlign: "center",
  },
}));

const DesktopBodySubTitle = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    marginTop: 120,
    textAlign: "center",
  },
  fontWeight: "500",
  fontSize: "20px",
  lineHeight: "26px",
  textTransform: "uppercase",
  color: "#FF768A",
  marginBottom: "16px",
}));
const DesktopBodyTitle = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    fontSize: "28px",
    textAlign: "center",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "38px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "48px",
    maxWidth: "62.42%",
  },
  fontWeight: "500",
  lineHeight: "63px",
  color: "#0D1615",
  marginBottom: "32px",

  "& span": {
    color: "#FF768A",
  },
}));
const DesktopButtonBody = styled(DesktopButton)(() => ({
  background: "#FED3E7",
  padding: "14px 24px",
}));

const DesktopBodySwimmingDog = styled("img")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    left: "0%",
  },
  position: "absolute",
  left: "20%",
  bottom: "91%",
  width: "173px",
}));
const MobileBodyCat = styled("img")(({ theme }) => ({
  width: "200px",
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));
const DesktopBodyCat = styled("img")(({ theme }) => ({
  position: "absolute",
  bottom: "2%",
  right: "5%",
  width: "500px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    width: "300px",
  },
  [theme.breakpoints.down("lg")]: {
    width: "300px",
  },
}));
const DesktopFooter = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    position: "relative",
  },
  paddingTop: "120px",
  background:
    "url(/assets/images2/lp-footer-bg.png) no-repeat bottom -300px center",
  backgroundSize: "cover",
}));
const DesktopContentCatHand = styled("img")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
  position: "absolute",
  top: "3px",
  left: "10%",
  width: "100px",
  transform: "rotate(180deg)",
}));
const MobileContentCatHand = styled("img")(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
  position: "absolute",
  bottom: "-12.5%",
  left: "5%",
  width: "100px",
  transform: "rotate(180deg)",
}));
const ReviewerGuideInstall = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    display: "flex",
  },
  marginTop: 40,
}));
const DesktopExplore = styled(Box)(() => ({}));
const DesktopExploreSubTitle = styled(Box)(() => ({
  marginBottom: "24px",
  textAlign: "center",
}));
const DesktopExploreTitle = styled(Box)(() => ({
  fontWeight: "500",
  fontSize: "60px",
  lineHeight: "79px",
  textAlign: "center",
  marginBottom: "36px",
}));
const DesktopExploreBlock = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  background: "#FFFFFF",
  border: "2px solid #0D1615",
  boxShadow: "3px 3px 0px #0D1615",
  minHeight: "270px",
  padding: "40px",
}));
const DesktopExploreBlockPicture = styled(Box)(() => ({
  flexGrow: 1,
  width: "72px",

  "& img": {
    width: "100%",
  },
}));
const DesktopExploreBlockTitle = styled(Box)(() => ({
  fontWeight: "500",
  fontSize: "20px",
  lineHeight: "26px",
  marginBottom: "16px",
}));
const DesktopExploreBlockDescription = styled(Box)(() => ({
  fontWeight: "300",
  fontSize: "14px",
  lineHeight: "18px",
}));
const DesktopFooterMenu = styled(Box)(({ theme }) => ({
  marginTop: "125px",
  padding: "24px 0",
  borderTop: "1px solid #0D1615",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));
const MobileFooterMenu = styled(Box)(({ theme }) => ({
  marginTop: "125px",
  padding: "24px 0",
  borderTop: "1px solid #0D1615",
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));
const DesktopFooterMenuContent = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
}));

const DesktopFooterLogoName = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    justifyContent: "center",
  },
  flexGrow: 1,
  display: "flex",
  lineHeight: "32px",
  "& img": {
    height: "32px",
    marginRight: "8px",
  },
}));

const DesktopFooterContact = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    justifyContent: "center",
    marginTop: 15,
    marginBottom: 15,
  },
  display: "flex",
  lineHeight: "28px",
  marginRight: "16px",
  "& svg": {
    height: "28px",
    marginRight: "12px",
  },
  "& a": {
    color: "#0D1615",
  },
}));

const DesktopFooterCatLeft = styled("img")(({ theme }) => ({
  position: "absolute",
  bottom: "147%",
  left: "0",
  width: "147px",

  [theme.breakpoints.up("xl")]: {
    left: "-147px",
  },
}));

const DesktopFooterCatRight = styled("img")(({ theme }) => ({
  position: "absolute",
  bottom: "91%",
  right: "0",
  width: "164px",

  [theme.breakpoints.up("xl")]: {
    right: "-164px",
  },
  [theme.breakpoints.down("sm")]: {
    bottom: "98%",
    right: "35px",
    width: "140px",
  },
}));

const Page = () => {
  const [openSideBar, setOpenSideBar] = useState(false);
  const { code } = useParams();
  const navigate = useNavigate();
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const { address } = useAccounts();
  const { logout } = useContext(AuthContext);

  const handleConnect = async () => {
    if (address) {
      await logout();
      return;
    }
    setOpenLoginModal(true);
  };

  const handleGoToApp = () => {
    window.location.href = ENVS.REACT_APP_APP_ENDPOINT;
  };

  const toggleDrawer =
    (anchor: any, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }
      setOpenSideBar(!openSideBar);
    };

  useEffect(() => {
    if (code) {
      navigate('https://raydium.io/swap/?outputMint=5zYbnE6UXTn6HMTPXCNPW61iA1vyCNTZLVQdUUnoazB&inputMint=sol');
      //navigate(`/pre-sale?invite-code=${code}`);
    }
  }, [code]);
  return (
    <DesktopContent>
      <SwipeableDrawer
        anchor={"left"}
        open={openSideBar}
        onClose={toggleDrawer("left", false)}
        onOpen={toggleDrawer("left", true)}
        className="side-bar-pet"
      >
        <List style={{ height: "100%", background: "#fef2d4" }}>
          <ListItem
            disablePadding
            style={{
              justifyContent: "center",
              marginTop: 10,
              marginBottom: 50,
            }}
          >
            <Link href="/">
              <DesktopLogo src={"/assets/images2/lp-logo.svg"} />
            </Link>
          </ListItem>
          <ListItem
            disablePadding
            style={{ justifyContent: "center", marginBottom: 20 }}
          >
            <Link href="https://docs.manekopet.xyz">
              <DesktopButton>DOCS</DesktopButton>
            </Link>
          </ListItem>
          <ListItem
            disablePadding
            style={{ justifyContent: "center", marginBottom: 20 }}
          >
            <Link href="https://discord.gg/58cNaFBWaN">
              <DesktopButton>COMMUNITY</DesktopButton>
            </Link>
          </ListItem>
          <ListItem
            disablePadding
            style={{ justifyContent: "center", marginBottom: 20 }}
          >
            <Link href="https://raydium.io/swap/?outputMint=5zYbnE6UXTn6HMTPXCNPW61iA1vyCNTZLVQdUUnoazB&inputMint=sol">
              <DesktopButton>BUY $MP</DesktopButton>
            </Link>
          </ListItem>
          <ListItem
            disablePadding
            style={{ justifyContent: "center", marginBottom: 20 }}
          >
            {/* <MobileButtonPS
              startIcon={
                <img
                  src={"/assets/images2/lp-start-icon-public-sale.gif"}
                  alt="star"
                />
              }
            >
              Public Sale <span>(COMING SOON)</span>
            </MobileButtonPS> */}
            <Link href="https://play.manekopet.xyz">
              <DesktopButton>PLAY</DesktopButton>
            </Link>
          </ListItem>
          {address && (
            <ListItem
              disablePadding
              style={{ justifyContent: "center", marginBottom: 20 }}
            >
              <DesktopButton
                onClick={() => {
                  navigator.clipboard.writeText(address);
                  toast.success("Copy address success");
                }}
              >
                {addressShorten(address)}
              </DesktopButton>
            </ListItem>
          )}
          <ListItem
            disablePadding
            style={{ justifyContent: "center", marginBottom: 20 }}
          >
            <Button onClick={handleConnect}>
              {!address ? "Connect" : "Logout"}
            </Button>
          </ListItem>
        </List>
        <MobileFooterMenu style={{ marginTop: 0, background: "#fef2d4" }}>
          <Container maxWidth={"lg"}>
            <DesktopFooterContact>
              <FooterEmailIcon />
              <Link href="mailto:hello@manekopet.xyz" underline="none">
                hello@manekopet.xyz
              </Link>
            </DesktopFooterContact>
            <DesktopFooterMenuContent>
              <DesktopFooterContact>
                <FooterDiscordIcon />
                <Link
                  href="https://discord.gg/58cNaFBWaN"
                  style={{ fontSize: 14 }}
                  underline="none"
                >
                  Discord
                </Link>
              </DesktopFooterContact>
              <DesktopFooterContact>
                <FooterTwitterIcon />
                <Link
                  href="https://twitter.com/manekosol"
                  style={{ fontSize: 14 }}
                  underline="none"
                >
                  Twitter
                </Link>
              </DesktopFooterContact>
              <DesktopFooterContact>
                <FooterTelegramIcon />
                <Link
                  href="https://t.me/manekopet"
                  style={{ fontSize: 14 }}
                  underline="none"
                >
                  Telegram
                </Link>
              </DesktopFooterContact>
            </DesktopFooterMenuContent>
          </Container>
        </MobileFooterMenu>
      </SwipeableDrawer>
      <DesktopHeader>
        <DesktopTopMenu>
          <Container maxWidth="lg">
            <Grid container>
              <Grid item xs>
                <Link href="https://docs.manekopet.xyz">
                  <DesktopButton sx={{ mr: 1 }}>DOCS</DesktopButton>
                </Link>
                <Link href="https://discord.gg/58cNaFBWaN">
                  <DesktopButton>COMMUNITY</DesktopButton>
                </Link>
                <Link href="https://raydium.io/swap/?outputMint=5zYbnE6UXTn6HMTPXCNPW61iA1vyCNTZLVQdUUnoazB&inputMint=sol">
                  <DesktopButton sx={{ ml: 1 }}>BUY $MP</DesktopButton>
                </Link>
              </Grid>
              <Grid item width="auto">
                <Link href="/">
                  <DesktopLogo src={"/assets/images2/lp-logo.svg"} />
                </Link>
              </Grid>

              <Grid item xs sx={{ textAlign: "right" }}>
                <Link href="/stake">
                  <DesktopButton style={{ marginRight: 12 }}>
                    Stake
                  </DesktopButton>
                </Link>
                <Link href="https://play.manekopet.xyz">
                  <DesktopButton>PLAY</DesktopButton>
                </Link>

                {address && (
                  <DesktopButton
                    onClick={() => {
                      navigator.clipboard.writeText(address);
                      toast.success("Copy address success");
                    }}
                    style={{ marginLeft: 12 }}
                  >
                    {addressShorten(address)}
                  </DesktopButton>
                )}
                <DesktopButton
                  onClick={handleConnect}
                  style={{ marginLeft: 12 }}
                >
                  {!address ? "Connect Wallet" : "Logout"}
                </DesktopButton>
                {/* <DesktopButtonPS
                    startIcon={
                      <img
                        src={"/assets/images2/lp-start-icon-public-sale.gif"}
                        alt="star"
                      />
                    }
                  >
                    Public Sale <span>(COMING SOON)</span>
                  </DesktopButtonPS> */}
              </Grid>
            </Grid>
          </Container>
        </DesktopTopMenu>
        <MobileTopMenu>
          <Container maxWidth="lg">
            <Grid container>
              <Grid item xs></Grid>
              <Grid width="auto">
                <Link href="/">
                  <DesktopLogo src={"/assets/images2/lp-logo.svg"} />
                </Link>
              </Grid>
              <Grid item xs sx={{ textAlign: "right", zIndex: 9999 }}>
                {!openSideBar ? (
                  <MenuIcon onClick={() => setOpenSideBar(true)} />
                ) : (
                  <MenuCloseIcon onClick={() => setOpenSideBar(false)} />
                )}
              </Grid>
            </Grid>
          </Container>
        </MobileTopMenu>
      </DesktopHeader>

      <DesktopBannerAppLeft src={"/assets/images2/lp-banner-app-left.png"} />
      <DesktopBannerAppRight src={"/assets/images2/lp-banner-app-right.png"} />

      <DesktopBody>
        <DesktopBodyWrapper>
          <Container maxWidth="lg">
            <DesktopBodySubTitle>About</DesktopBodySubTitle>
            <DesktopBodyTitle>
              Meet Maneko - mobile game
              <br />
              blending tamagotchi
              <br />
              nostalgia with modern
              <br />
              <span>blockchain tech.|</span>
            </DesktopBodyTitle>
            <Link href="https://discord.gg/58cNaFBWaN">
              <DesktopButtonBody>JOIN COMMUNITY</DesktopButtonBody>
            </Link>
            <MobileBodyCat src={"/assets/images2/lp-content-cat.gif"} />
          </Container>
          <DesktopBodySwimmingDog
            src={"/assets/images2/lp-content-swimming-dog.gif"}
          />
          <DesktopBodyCat src={"/assets/images2/lp-content-cat.gif"} />
          <MobileContentCatHand
            src={"/assets/images2/lp-content-cat-hand.gif"}
          />
        </DesktopBodyWrapper>
      </DesktopBody>

      <DesktopFooter>
        <DesktopExplore>
          <Container maxWidth={"lg"}>
            <DesktopExploreSubTitle>FEATURES</DesktopExploreSubTitle>
            <DesktopExploreTitle>Explore Maneko</DesktopExploreTitle>
            <Grid container spacing={2}>
              <Grid item md={4} style={{ width: "100%" }}>
                <DesktopExploreBlock>
                  <DesktopExploreBlockPicture>
                    <img
                      src={"/assets/images2/lp-explore-customize.svg"}
                      alt="customize"
                    />
                  </DesktopExploreBlockPicture>
                  <DesktopExploreBlockTitle>Customize</DesktopExploreBlockTitle>
                  <DesktopExploreBlockDescription>
                    Deck out Maneko in unique styles.
                  </DesktopExploreBlockDescription>
                </DesktopExploreBlock>
              </Grid>
              <Grid item md={4} style={{ width: "100%" }}>
                <DesktopExploreBlock>
                  <DesktopExploreBlockPicture>
                    <img
                      src={"/assets/images2/lp-explore-nurture.svg"}
                      alt="nurture"
                    />
                  </DesktopExploreBlockPicture>
                  <DesktopExploreBlockTitle>Nurture</DesktopExploreBlockTitle>
                  <DesktopExploreBlockDescription>
                    Feed, clean, and play to keep your Maneko happy and healthy.{" "}
                  </DesktopExploreBlockDescription>
                </DesktopExploreBlock>
              </Grid>
              <Grid item md={4} style={{ width: "100%" }}>
                <DesktopExploreBlock>
                  <DesktopExploreBlockPicture>
                    <img
                      src={"/assets/images2/lp-explore-battle.svg"}
                      alt="battle"
                    />
                  </DesktopExploreBlockPicture>
                  <DesktopExploreBlockTitle>Battle</DesktopExploreBlockTitle>
                  <DesktopExploreBlockDescription>
                    Compete against others, and win Rewards
                  </DesktopExploreBlockDescription>
                </DesktopExploreBlock>
              </Grid>
            </Grid>
          </Container>
        </DesktopExplore>
        <DesktopContentCatHand
          src={"/assets/images2/lp-content-cat-hand.gif"}
        />
        <DesktopFooterMenu>
          <Container maxWidth={"lg"} sx={{ position: "relative" }}>
            <DesktopFooterMenuContent>
              <DesktopFooterLogoName>
                <img src={"/assets/images2/lp-logo.svg"} alt="logo" />
                MANEKO
              </DesktopFooterLogoName>
              <DesktopFooterContact>
                <FooterEmailIcon />
                <Link href="mailto:hello@manekopet.xyz" underline="none">
                  hello@manekopet.xyz
                </Link>
              </DesktopFooterContact>
              <DesktopFooterContact>
                <FooterDiscordIcon />
                <Link href="https://discord.gg/58cNaFBWaN" underline="none">
                  Discord
                </Link>
              </DesktopFooterContact>
              <DesktopFooterContact>
                <FooterTwitterIcon />
                <Link href="https://twitter.com/manekosol" underline="none">
                  Twitter
                </Link>
              </DesktopFooterContact>
              <DesktopFooterContact>
                <FooterTelegramIcon />
                <Link href="https://t.me/manekopet" underline="none">
                  Telegram
                </Link>
              </DesktopFooterContact>
            </DesktopFooterMenuContent>
            <DesktopFooterCatLeft
              src={"/assets/images2/lp-footer-cat-left.gif"}
            />
            <DesktopFooterCatRight
              src={"/assets/images2/lp-footer-cat-right.gif"}
            />
          </Container>
        </DesktopFooterMenu>
        <MobileFooterMenu>
          <Container maxWidth={"lg"} sx={{ position: "relative" }}>
            <DesktopFooterLogoName>
              <img src={"/assets/images2/lp-logo.svg"} alt="logo" />
              MANEKO
            </DesktopFooterLogoName>
            <DesktopFooterContact>
              <FooterEmailIcon />
              <Link href="mailto:hello@manekopet.xyz" underline="none">
                hello@manekopet.xyz
              </Link>
            </DesktopFooterContact>
            <DesktopFooterMenuContent>
              <DesktopFooterContact>
                <FooterDiscordIcon />
                <Link
                  href="https://discord.gg/58cNaFBWaN"
                  style={{ fontSize: 14 }}
                  underline="none"
                >
                  Discord
                </Link>
              </DesktopFooterContact>
              <DesktopFooterContact>
                <FooterTwitterIcon />
                <Link
                  href="https://twitter.com/manekosol"
                  style={{ fontSize: 14 }}
                  underline="none"
                >
                  Twitter
                </Link>
              </DesktopFooterContact>
              <DesktopFooterContact>
                <FooterTelegramIcon />
                <Link
                  href="https://t.me/manekopet"
                  style={{ fontSize: 14 }}
                  underline="none"
                >
                  Telegram
                </Link>
              </DesktopFooterContact>
            </DesktopFooterMenuContent>
            <DesktopFooterCatRight
              src={"/assets/images2/lp-footer-cat-right.gif"}
            />
          </Container>
        </MobileFooterMenu>
      </DesktopFooter>
      <ConnectWallet
        openLoginModal={openLoginModal}
        setOpenLoginModal={(b: boolean) => setOpenLoginModal(b)}
      />
    </DesktopContent>
  );
};

export default Page;
